import FilesystemListContainer from "./FilesystemListContainer";
import { FilesystemStore, FilesystemHierarchyContext } from './Contexts'; 
import useGetter from './useGetter';
import G from './Getters';
//iimport { FilesystemHierarchyContext } from './Contexts';

import { 
  FILESYSTEM_NAME,
} from './Filesystem';

import { FIGURE_PANELS } from './RecordTypes';

import { 
  LAST_EDITED_DATE,
  CREATION_DATE,
} from './FieldConstants';




export default function FilesystemContainer({
  hierarchy,
  onEvent,
  root,
  list,
  setSelectedItem,
  selectedItem,
}){



  const topLevelDirectoryId = useGetter("getTopLevelDirectoryId",{type:"publications"});

  let hierarchyContext = (
    <FilesystemHierarchyContext.Provider value={{ }}>
    </FilesystemHierarchyContext.Provider>
  )

  return (

    <FilesystemHierarchyContext.Provider value={{
      [FIGURE_PANELS]:(state,_id) => {
        return {
          siblings:[
            {type:"virtual",_id:"1"},
            {type:FIGURE_PANELS,_id},
            {type:"virtual",_id:"2"},

          ]
        }
      }
    }}>

      <FilesystemStore.Provider value={{
        isFilesystemItemSelected:(_id) => {
          return _id === selectedItem._id
        },
        onFilesystemItemEvent:({_id,event,item}) => {
          setSelectedItem(item)
        }

      }}>

        <FilesystemListContainer {...{



          topLevelDirectoryId
        }}>
        </FilesystemListContainer>



      </FilesystemStore.Provider>
    </FilesystemHierarchyContext.Provider>


  )



}
